import { PointLocation, PointType } from "src/app/pages/custom-route/interfaces/custom-route.interface";
import { CategoryPoint } from "src/app/pages/custom-route/interfaces/custom-route.response";

export interface EditedCustomRoute {
  id: number;
  dailyRoutes: EditedDailyRoute[];
}

export interface EditedDailyRoute {
  id: number;
  date: Date | any;
  weatherIconName: string;
  points: EditedPoint[];
  startPoint: PointLocation;
  endPoint?: PointLocation;
}

export interface EditedPoint {
  id: number;
  type: PointType;
  categoryList: CategoryPoint;
  img: string;
  //status: ItemStatus; // 'pending', 'running', 'finished' Backend does not return this field
  status?: EditedStatus; // 'deletedpoint', 'oldpoint', 'updatedpoint', 'addedpoint' // Backend does not return this field
  title: string;
  startDate: Date; 
  endDate: Date; 
  duration: number;
  previousLocation: PointLocation;
  currentLocation: PointLocation;
  //polylinesPath: PointLocation[]; Backend does not return this field
  //totalTransferDistance: number; Backend does not return this field
  //totalTransferDuration: number;  Backend does not return this field
  //transfers: Transfers[]; Backend does not return this field
  //transportList: Transport[] | null;  Backend does not return this field
  nextPoint: string;
  transferPathDistances?: any;
}

export enum EditedStatus {
  DELETED = 'deletedpoint',
  OLD = 'oldpoint',
  UPDATED = 'updatedpoint',
  ADDED = 'addedpoint'
}

export interface GetSuggestedPointsBody {
  token: string;
  day: string; // '2023-10-01'
  duration: number; // in minutes
  startTime: string; // '09:00'
  previousPoint?: previousPointBody;
  nextPoint?: nextPointBody;
}

export interface previousPointBody {
  id: number;
  type: PointType;
}

export interface nextPointBody {
  id: number;
  type: PointType;
}

export interface UpdateCustomEditedRouteBody {
  token: string;
  date: string; // '2023-10-01'
  points: EditedPointBody[];
}

interface EditedPointBody {
  id: number;
  title: string;
  type: PointType;
  status: EditedStatus;
  startDate: string; // '2023-10-01T09:00:00'
}